import React from 'react';
import useAuth from '../hooks/useAuth.ts';

const UnauthorizedAccess: React.FC = () => {
  const { auth } = useAuth();
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '50vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h2>Access Denied</h2>
      <p>You don't have permission to access this page.</p>
      <p>Your current role: <strong>{auth.user?.role || 'Unknown'}</strong></p>
      <p>Please contact your administrator if you believe this is an error.</p>
      <button 
        onClick={() => window.history.back()}
        style={{
          marginTop: '1rem',
          padding: '0.5rem 1rem',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Go Back
      </button>
    </div>
  );
};

export default UnauthorizedAccess;
